import { Form, Input } from "antd";

/**
 * Reusable Organization Form Component
 * @param {Object} organization - Organization data object
 * @param {Function} onChange - Handler for form changes (receives partial update object)
 * @param {Function} translate - Translation function
 */
export const OrganizationForm = ({
  organization,
  onChange,
  translate = (key) => key,
}) => {
  return (
    <Form layout="vertical">
      <Form.Item label={translate("organizations.orgName")}>
        <Input
          name="name"
          value={organization.name}
          onChange={(e) => onChange({ name: e.target.value })}
        />
      </Form.Item>

      <Form.Item label={translate("organizations.description")}>
        <Input.TextArea
          name="description"
          value={organization.description}
          onChange={(e) => onChange({ description: e.target.value })}
          rows={4}
        />
      </Form.Item>
    </Form>
  );
};
